<template>
	<el-dialog
		:title="sectionDetails.id ? 'Update Section' : 'Add Section'"
		:visible.sync="showSections"
		custom-class="custom-class-add-or-edit-section"
		:center="true"
		:append-to-body="appendToBody"
	>
		<el-row :gutter="20" class="mb-8">
			<el-col :span="24">
				<div style="display: flex; justify-content: space-between" class="mb-2">
					<h2 class="popup-title">{{ sectionDetails.id ? 'Update Section' : 'Add Section' }}</h2>
					<!-- <el-button
						icon="el-icon-close"
						size="mini"
						circle
						@click="showSections = false"
					></el-button> -->
					<span class="cursor-pointer" style="font-size: 28px; color: #333;" @click="showSections = false">
						<i class="el-icon-circle-close"></i>
					</span>
				</div>
			</el-col>
		</el-row>
		<el-input
			v-model="sectionDetails.name"
			size="small"
			placeholder="Section Name"
		></el-input>
		<div class="mt-6 text-right">
			<el-button type="warning" size="small" class="primary-settings-button__save" round @click="saveSection">Save</el-button>
		</div>
	</el-dialog>
</template>

<script>
import { mapState } from "vuex";
import labourPalnningService from "../../../../../services/labourPalnningService";
import settingsMixin from "../../../../../../mixins/settingsMixin";
export default {
	name: "AddOrEditSection",
	mixins: [settingsMixin],
	props: {
        appendToBody: {
            default: false,
            type: Boolean
        }
    },
	computed: {
		...mapState("SettingStore", [
			"sectionData",
			"showSectionModal",
			"selectedOutlet",
			"storeSections",
		]),
		showSections: {
			get() {
				return this.showSectionModal;
			},
			set(val) {
				this.$store.commit("SettingStore/updateShowSection", val);
			},
		},
		sectionDetails: {
			get() {
				return this.sectionData;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSectionData", val);
			},
		},
		sections: {
			get() {
				return this.storeSections;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSections", val);
			},
		},
	},
	watch: {
		showSections(newValue, oldValue) {
			if (newValue === false) {
				this.sectionDetails = {
					store: "",
					department: null,
					name: "",
					applicable_functions: [],
					transaction_threshold: 0,
				};
			}
		},
	},
	methods: {
		saveSection() {
			if(this.sectionDetails.id) {
				let sectionIndex = this.company_level_sections.findIndex((el) => el.id === this.sectionDetails.id);
				const params = [...this.company_level_sections];
				if(sectionIndex !== -1) {
					params[sectionIndex] = {...this.sectionDetails};
					labourPalnningService
						.bulkSaveSectionsAtCompanyLevel(params)
						.then(async (response) => {
							await this.getAllSections();
							await this.getSections();
							this.showSections = false;
							this.resetSectionDetails();
						})
						.catch((err) => console.error(err.response.data));
				}
			} else {
				const find = this.company_level_sections.find(
					(el) => el.name == this.sectionDetails.name && !this.sectionDetails.id
				);
				if (find === undefined) {
					if(this.sectionDetails.name) {
						let sectionData = {
							name: this.sectionDetails.name,
						};
						const params = [...this.company_level_sections, sectionData];
						labourPalnningService
							.bulkSaveSectionsAtCompanyLevel(params)
							.then(async (response) => {
								await this.getAllSections();
								await this.getSections();
								this.resetSectionDetails();
								this.showSections = false;
							})
							.catch((err) => console.error(err.response.data));
					}
				} else {
					this.$notify.error({
						title: "Duplicate Entry",
						message: "Section name already exist!",
					});
				}
			}
		},
	},
};
</script>

<style lang="scss">
.company-settings .custom-class-add-or-edit-section {
	.el-dialog__header {
		display: none;
	}
	.el-message-box__wrapper {
		.el-button--primary {
			background: #e29d5a !important;
			border-color: #e29d5a !important;
		}
	}
}
</style>
